export const assets = {
  logo: 'assets/images/logo.svg',
  authBg: 'assets/images/auth_bg.png',
  fbIcon: 'assets/images/fb_icon.svg',
  googleIcon: 'assets/images/google_icon.svg',
  cameraIcon: 'assets/images/camera_icon.svg',
  userIcon: 'assets/images/user_icon.svg',
  notiIcon: 'assets/images/noti_icon.svg',
  SearchIcon: 'assets/images/search_icon.svg',
  SearchIcon2: 'assets/images/searc_icon.svg',
  SocialIcon: 'assets/images/facebook_icon.svg',
  SocialIcon2: 'assets/images/insta_icon.svg',
  SocialIcon3: 'assets/images/twitter_icon.svg',
  bannerImage: 'assets/images/home_banner.png',
  ModuleImg: 'assets/images/md_img.png',
  tutorImage: 'assets/images/tutor_img.png',
  tutorImage5: 'assets/images/tutor_img5.png',
  tutorImage2: 'assets/images/tutor_img2.png',
  chatIcon: 'assets/images/msg_icon.png',
  BookingIcon: 'assets/images/booking-icon.png',
  inboxIcon: 'assets/images/inbox-icon.svg',
  doubleCheck: 'assets/images/double_check.svg',
  playStore: 'assets/images/play_store.png',
  AppStore: 'assets/images/app_store.png',
  HeaderIcon: 'assets/images/header_icon.svg',
  HeaderIcon2: 'assets/images/header_icon2.svg',
  HeaderIcon3: 'assets/images/header_icon3.svg',
  HeaderIcon4: 'assets/images/header_icon4.svg',
  HeaderIcon5: 'assets/images/header_icon5.svg',
  HeaderIcon6: 'assets/images/header_icon6.svg',
  UserDp: 'assets/images/user_dp.png',
  UserDp2: 'assets/images/user_dp2.jpg',
  courseImg: 'assets/images/course_img.jpg',
  DetailImg: 'assets/images/dtl_img.png',
  notesImg: 'assets/images/notes_img.png',
  VideoImg: 'assets/images/video_img.jpg',
  sendIcon: 'assets/images/send_icon.svg',
  ProductImg: 'assets/images/product_img.png',
  ProductImg2: 'assets/images/product_img2.png',
  ProductImg11: 'assets/images/product_img11.png',
  ProductImg22: 'assets/images/product_img22.png',
  ProductImg33: 'assets/images/product_img33.png',
  ProductImg44: 'assets/images/product_img44.png',
  ProductImg45: 'assets/images/new_product.png',
  DocIcon: 'assets/images/doc_icon.svg',
  supportBg: 'assets/images/support_bg.png',
  ChatIcon: 'assets/images/chat_icon.svg',
  PhoneIcon: 'assets/images/phone_icon.svg',
  WriteIcon: 'assets/images/write_icon.svg',
  virtualImage: 'assets/images/virtual_img.jpg',
  giftIcon: 'assets/images/gift_icon.svg',
  walletIcon: 'assets/images/wallet_icon.svg',
  locationIcon: 'assets/images/location_icon.svg',
  deleteIcon: 'assets/images/delete_icon.svg',
  ProfileDp: 'assets/images/profile_dp2.png',
  TeacherIcon: 'assets/images/teacher_icon.svg',
  VisaIcon: 'assets/images/visa_icon.png',
  MasterIcon: 'assets/images/master_icon.png',
  cards: 'assets/images/cards.png',
  trashIcon: 'assets/images/trash_icon.svg',
  multiuserIcon: 'assets/images/multiuser_icon.svg',
  threadIcon: 'assets/images/thread_icon2.svg',
  certicateImage: 'assets/images/certificate_img.png',
  contactImage: 'assets/images/contact_img.png',
  ContactList1: 'assets/images/contact_list1.svg',
  ContactList2: 'assets/images/contact_list2.svg',
  ContactList3: 'assets/images/contact_list3.svg',
  addImage: 'assets/images/add_img.png',
  feedImage: 'assets/images/feed_img.jpg',
  floatIcon: 'assets/images/float_icon.svg',
  floatIcon2: 'assets/images/float_icon2.svg',
  floatIcon3: 'assets/images/float_icon3.svg',
  floatIcon4: 'assets/images/float_icon4.svg',
  wishlistIcon: 'assets/images/wishlist_icon.svg',
  visCard: 'assets/images/visa_card.png',
  ofIcon: 'assets/images/off_icon.svg',
  onIcon: 'assets/images/on_icon.svg',
  docImg: 'assets/images/doc_img.png',
  reportIcon: 'assets/images/report_icon.svg',
  pdfIcon: 'assets/images/pdf.png',
  paymentSuccess: 'assets/images/payment_success.png',
  plusIcon: 'assets/images/plus_icon.svg'

};
